import { memo, useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";
import { StockTable } from "@/components/features/items/stock/_shared/components/table";
import { StockTableHeader } from "@/components/features/items/stock/_shared/components/table/header";

import { PlanStockTableRows } from "./components/rows";
import { usePlanStockTablePresenter } from "./hooks/use-plan-table-presenter";

import type { PlanStockDiffStore } from "../../../../../model/usecase/use-create-form-model/plan-stock-diff-store";
import type { ServerModel } from "../../../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	planStockDiffStore: PlanStockDiffStore;

	selectedItemIDs: string[];
};

export const PlanStockTableFoLaptop = memo(({ serverModel, planStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredViewModel, currentMonth, currentYear } = usePlanStockTablePresenter({
		serverModel,
		planStockDiffStore,
		selectedItemIDs,
	});

	const { headers, items, hotelID } = filteredViewModel;

	/**
	 * 在庫一覧を表示するか
	 */
	const canShowStockList = useMemo(() => items.length > 0, [items.length]);

	return (
		<StockTable currentYearAndMonth={{ year: currentYear, month: currentMonth }}>
			{canShowStockList ? (
				<>
					<StockTableHeader headers={headers} />
					<PlanStockTableRows items={items} hotelID={hotelID} planStockDiffStore={planStockDiffStore} />
				</>
			) : (
				<BlankContentForList content="表示するプランがありません。" />
			)}
		</StockTable>
	);
});

PlanStockTableFoLaptop.displayName = "PlanStockTableFoLaptop";
